import { gaUtils as GoogleAnalytics } from '@space-core/analytics'
import { System } from '@space-core/datahub'

import type { GoogleAnalyticsProps, UseGoogleAnalyticsProps } from './types'

export const useGoogleAnalytics = ({ userId, locale }: UseGoogleAnalyticsProps) => ({
  sendGoogleAnalyticsEvent: ({ group, name, label }: GoogleAnalyticsProps) => {
    GoogleAnalytics.registerInteraction({
      section: System.MEMBERSHIP_CONSUMER,
      category: group,
      action: name,
      ...(label && { label }),
      language: locale,
      logged: userId
    })
  }
})
